/**
 * Génère un UUID v4.
 *
 * `crypto.randomUUID()` n'est exposé que dans un contexte sécurisé (HTTPS ou
 * localhost). En HTTP simple, ce qui arrive dès qu'on teste depuis un téléphone sur
 * le réseau local, il est absent et l'appel lève une TypeError qui casse tout
 * le démarrage.
 *
 * `crypto.getRandomValues()`, lui, reste disponible partout : on s'en sert pour
 * fabriquer l'UUID à la main. Le format doit rester conforme, le Worker le
 * valide par expression régulière avant d'écrire en base.
 */
export function uuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }

  const o = new Uint8Array(16)
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(o)
  } else {
    for (let i = 0; i < 16; i++) o[i] = Math.floor(Math.random() * 256)
  }

  o[6] = (o[6]! & 0x0f) | 0x40 // version 4
  o[8] = (o[8]! & 0x3f) | 0x80 // variante RFC 4122

  const h = Array.from(o, (b) => b.toString(16).padStart(2, "0")).join("")
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
}
